import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetPersonalizedLiveEvents = QueryFactory(SD.QueryTypes.GetPersonalizedLiveEvents);
//# sourceMappingURL=QGetPersonalizedLiveEvents.js.map